/** 3s pause → full stop. Shared by STT-lab and the interview room. */

export const PAUSE_MS = 3000;

export function stripEndStop(text) {
  return String(text || '').replace(/[.!?]+$/g, '').trim();
}

export function withFullStop(text) {
  const t = String(text || '').replace(/\s+/g, ' ').trim();
  if (!t) return t;
  if (/[.!?]$/.test(t)) return t;
  return `${t}.`;
}
